<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="modal-header">
  <h4 class="modal-title">
    <span *ngIf="company && company.id">{{ 'COMPANIES.COMPANIES_FORM.EDIT' | translate }}</span>
    <span *ngIf="!company || !company.id">{{ 'COMPANIES.COMPANIES_FORM.ADD' | translate }}</span>
  </h4>
  <button type="button" class="close btn-close-templates" aria-label="Close" (click)="modal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<ng-scrollbar class="modal-body ps">
  <form id="company-form" (ngSubmit)="save()" [formGroup]="form" novalidate>
    <div class="row">
      <div class="col-sm-2 text-center">
        <app-image-input [form]="form" controlName="logo" newControlName="new_logo"></app-image-input>
      </div>
      <div class="col-sm-10">
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label>{{ 'COMPANIES.COMPANIES_FORM.NAME' | translate }}</label>
              <input type="text" class="form-control" formControlName="name" />
            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <app-cities-select [parentFormGroup]="form"></app-cities-select>
            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label>{{ 'COMPANIES.COMPANIES_FORM.ADDRESS' | translate }}</label>
              <input type="text" class="form-control" formControlName="address" />
            </div>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label>{{ 'COMPANIES.COMPANIES_FORM.ABBREVIATION' | translate }}</label>
              <input type="text" class="form-control" formControlName="abbreviation" />
            </div>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label>{{ 'COMPANIES.COMPANIES_FORM.REGISTRATION_NUMBER' | translate }}</label>
              <input type="text" class="form-control" formControlName="registration_number" />
            </div>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label>{{ 'COMPANIES.COMPANIES_FORM.TAX_NUMBER' | translate }}</label>
              <input type="text" class="form-control" formControlName="tax_number" />
            </div>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label>{{ 'COMPANIES.COMPANIES_FORM.VAT_NUMBER' | translate }}</label>
              <input type="text" class="form-control" formControlName="vat_number" />
            </div>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label>{{ 'COMPANIES.COMPANIES_FORM.IATA_TIDS_NUMBER' | translate }}</label>
              <input type="text" class="form-control" formControlName="iata_tids_number" />
            </div>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label>{{ 'COMPANIES.COMPANIES_FORM.COLOR' | translate }}</label>
              <div>
                <!--            z-index-a е сетнат в theme.scss-->
                <input type="color" formControlName="color" class="color-picker-custom" />
              </div>
            </div>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label>{{ 'COMPANIES.COMPANIES_FORM.VAT_PERCENT' | translate }}</label>
              <input type="number" class="form-control" formControlName="vat_percent" />
            </div>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label>{{ 'COMPANIES.COMPANIES_FORM.PROFORMA_PREFIX' | translate }}</label>
              <input type="text" class="form-control" formControlName="proforma_prefix" />
            </div>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label>{{ 'COMPANIES.COMPANIES_FORM.INVOICE_DIGITS_COUNT' | translate }}</label>
              <input type="number" class="form-control" formControlName="invoice_digits_count" />
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-12 mt-3">
        <app-contact [parentFormGroup]="form"></app-contact>
      </div>

      <!--      <div class="col-sm-12">-->
      <!--        <div class="form-group  mt-2">-->
      <!--          <app-property [parentFormGroup]="form"></app-property>-->
      <!--        </div>-->
      <!--      </div>-->

      <div class="col-sm-12">
        <div class="custom-control custom-checkbox checkbox-margin">
          <input type="checkbox" class="custom-control-input" formControlName="active" id="companies-form-active" />
          <label class="custom-control-label" for="companies-form-active">
            {{ 'COMPANIES.COMPANIES_FORM.ACTIVE' | translate }}
          </label>
        </div>
      </div>
    </div>
  </form>
</ng-scrollbar>

<div class="modal-footer">
  <button type="submit" class="btn btn-outline-dark btn-xs" form="company-form" [disabled]="form.invalid">
    {{ 'COMPANIES.COMPANIES_FORM.SAVE' | translate }}
  </button>
</div>
